import { GetUserAppSettingsQuery, UpdateUserAppSettingMutation } from "~/gql/queries/userAppSetting.generated";

export const userSettingsEndpoints = {
	GetUserAppSettings: {
		providesTags: ["UserAppSettings"] as AddTagTypes,
		transformResponse: (res: GetUserAppSettingsQuery) => res
	},
	UpdateUserAppSetting: {
		invalidatesTags: ["UserAppSettings"] as AddTagTypes,
		transformResponse: (res: UpdateUserAppSettingMutation) => res
	}
};
